var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"amount-indicator",class:[_vm.sizeClass, _vm.typeClass]},[_c('div',{staticClass:"d-flex align-items-baseline justify-content-center"},[_vm._v(" "+_vm._s(_vm.amount === 0 || _vm.amount > 0 ? _vm.amount : '-')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }